/**
 * ALLES GEREGELT — Public Pre-Launch Landingpage · Media-Referenzen
 * Alle Asset-Pfade zentral. Austausch = Datei in /public/ ersetzen und Pfad hier bei Bedarf anpassen.
 * Assets, die noch nicht vorhanden sind, bleiben `null` — Komponenten zeigen dann einen
 * ruhigen Fallback statt eine kaputte Datei zu laden.
 */

export const landingMedia = {
  // Video: /public/videos/hero.mp4  · /public/videos/hero.webm  · /public/videos/hero-poster.jpg
  heroVideo: null,
  heroVideoWebm: null,
  heroPoster: null,

  // Illustrationen für die Story-Sektion (optional)
  storyImage: null,

  // Vorschau-Grafik für den Lebensbaum (optional; sonst reine SVG-Präsentation)
  lifeTreeImage: null,

  // Vorschau-Grafik der Vertrauenskarte (optional)
  trustCardImage: null,

  // Familien-/People-Bild (optional)
  peopleImage: null,

  // LINA-Avatar/Illustration (optional — sonst reines Sparkles-Icon)
  linaImage: null,

  // Plattform-Screenshots
  platformScreenshots: {
    dashboard: null,
    lebensbaum: null,
    vault: null,
    trustcard: null,
  },

  // Social-Preview (Open Graph) — wird später in <head> gesetzt
  socialPreview: null,
};

export default landingMedia;
